(function () {
    const IMAGE_ATTRIBUTE_PREFIX = 'data-image-zoomable';
    const VIEWER_ATTRIBUTE_PREFIX = 'data-image-viewer-with-zoom';

    const goToPhoto =  (image) => window.location.hash = encodeURIComponent(image);

    const ImagesCollection = function () {};
    let fn = ImagesCollection.prototype;
    fn._getGroupByUrl = function (url) {
        const element = document.querySelector('['+IMAGE_ATTRIBUTE_PREFIX+'-image="' + url + '"]');
        return !element ? '' : element.getAttribute(IMAGE_ATTRIBUTE_PREFIX+'-group');
    };
    fn._indexOfByUrl = function (imagesOfGroup, url, result= -1) {
        for (let i = 0; i < imagesOfGroup.length; i++) {
            if(imagesOfGroup[i].getAttribute( IMAGE_ATTRIBUTE_PREFIX+'-image') === url){
                return i;
            }
        }
        return result;
    };
    fn._elementToData = function(element){
        return {
            src:  element.getAttribute(IMAGE_ATTRIBUTE_PREFIX+'-image'),
            caption: element.getAttribute(IMAGE_ATTRIBUTE_PREFIX+'-caption'),
            lowSrc: element.getAttribute(IMAGE_ATTRIBUTE_PREFIX+'-image-low-src'),
            width: parseInt(element.getAttribute(IMAGE_ATTRIBUTE_PREFIX+'-image-natural-width')),
            height: parseInt(element.getAttribute(IMAGE_ATTRIBUTE_PREFIX+'-image-natural-height')),
        };
    };
    fn.getImagesForViewerByUrl = function (url) {
        const result = {current: null, prev: null, next: null};
        const group = this._getGroupByUrl(url);
        const imagesOfGroup = document.querySelectorAll('['+IMAGE_ATTRIBUTE_PREFIX+'-group="' + group + '"]');
        if (imagesOfGroup.length === 0) {
            return result;
        }
        const index = this._indexOfByUrl(imagesOfGroup, url);
        result.current = this._elementToData(imagesOfGroup[index]);
        if(index > 0){
            result.prev = this._elementToData(imagesOfGroup[index - 1]);
        }
        if(index < imagesOfGroup.length - 1){
            result.next = this._elementToData(imagesOfGroup[index + 1]);
        }
        return result;
    };

    const Viewer = function (element) {
        this.element = element;
        this.imageContainer = element.querySelector('['+VIEWER_ATTRIBUTE_PREFIX+'-image-container]');
        this.caption = element.querySelector('['+VIEWER_ATTRIBUTE_PREFIX+'-caption]');
        this.btnPrev = element.querySelector('['+VIEWER_ATTRIBUTE_PREFIX+'-prev-button');
        this.btnNext = element.querySelector('['+VIEWER_ATTRIBUTE_PREFIX+'-next-button]');
        this.btnClose = element.querySelector('['+VIEWER_ATTRIBUTE_PREFIX+'-close-button]');

        this.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        this.images = {current:null, prev:null, next:null};

        const o = this;
        o.btnClose.addEventListener("click", function () {
            goToPhoto("");
        });
        o.btnPrev.addEventListener('click', function () {
            goToPhoto(o.images.prev.src);
        });
        o.btnNext.addEventListener('click', function () {
            goToPhoto(o.images.next.src);
        });
    };
    fn = Viewer.prototype;
    // elements getters
    fn.reset = function (images) {
        this.images = images;
        if(!!images.current){
            this.show(images);
        }else{
            this.hide();
        }
    };
    fn.show = function () {
        const o = this;
        o.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        o.element.style.display = 'block';

        const targetViewport = o.element.querySelector('#imageViewerWithZoomViewportImage');
        targetViewport.dispatchEvent(new CustomEvent('loadimage', {detail:o.images.current}));

        o.btnPrev.classList.remove("visible");
        o.btnNext.classList.remove("visible");

        if(o.images.prev){
            o.btnPrev.classList.add("visible");
        }

        if(o.images.next){
            o.btnNext.classList.add("visible");
        }
        this.caption.innerHTML = o.images.current.caption;
    };
    fn.hide = function () {
        const o = this;
        o.element.style.display = 'none';
        setTimeout(function(){
            window.scroll(0, o.scroll);
        }, 100);
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
        window.scroll(0, o.scroll);
    };

    const init = function (root) {
        const viewer = new Viewer(root);
        const collection = new ImagesCollection();

        const setKeyboardListeners = function () {
            document.addEventListener('keydown', function (e) {
                if (viewer.element.style.display === 'block') {
                    if (e.key === 'Escape') {
                        goToPhoto('');
                    }
                    if (e.key === 'ArrowRight') {
                        goToPhoto(viewer.images.next.src);
                    }
                    if (e.key === 'ArrowLeft' && !!viewer.images.prev) {
                        goToPhoto(viewer.images.prev.src);
                    }
                }
            });
        };

        const loadPhoto = function () {
            const url = !!window.location.hash ? decodeURIComponent(window.location.hash.substr(1)) : '';
            viewer.reset(collection.getImagesForViewerByUrl(url));
        };

        window.addEventListener('hashchange', loadPhoto);
        document.querySelectorAll('['+IMAGE_ATTRIBUTE_PREFIX+'-image]').forEach((image)=>{
            image.addEventListener('click',  () => {
                goToPhoto(image.getAttribute(IMAGE_ATTRIBUTE_PREFIX+'-image'));
            });
        });
        loadPhoto();
        setKeyboardListeners();
    };

    window.addEventListener('load', () => {
        document.querySelectorAll('['+VIEWER_ATTRIBUTE_PREFIX+']').forEach(init);
    }, false);

})();
